import type { PriceSource } from "@/lib/domain/PriceSource";
import { useHTTP, useHTTPMutation, type HTTPResponse } from "@/lib/http";
import { useQueryClient, type MutationFunction } from "@tanstack/react-query";

export interface SetPreferredPriceSourceRequestModel {
	readonly priceSource: PriceSource;
}

export const useSetPreferredPriceSource = () => {
	const http = useHTTP("Required");
	const queryClient = useQueryClient();

	const mutationFn: MutationFunction<HTTPResponse, SetPreferredPriceSourceRequestModel> = requestModel => {
		return http<undefined, SetPreferredPriceSourceRequestModel>({
			method: "POST",
			url: "/settings/preferred-price-source",
			body: requestModel
		});
	};

	return useHTTPMutation({
		mutationFn,
		onSuccess: (_, requestModel) => {
			queryClient.resetQueries();
			queryClient.setQueryData(["preferredPriceSource"], requestModel);
		}
	});
};
